import { Label } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';
import type { SeedingLabelVariant } from '../types';

interface StatusLabelBadgeProps {
  /** 상태 색상 variant. null/undefined 이면 미노출 */
  variant: SeedingLabelVariant;
  /** 라벨 텍스트 (예: "배송중", "콘텐츠 등록 완료", "품절") */
  label: string;
  className?: string;
}

export const StatusLabelBadge = ({ variant, label, className }: StatusLabelBadgeProps) => {
  if (!variant) return null;
  return (
    <Label
      variant={variant}
      className={twMerge('rounded-sm px-[6px]! py-[2px]! text-[12px] font-medium', className)}
    >
      {label}
    </Label>
  );
};
